import type {FC} from 'react';
import clsx from 'clsx';

import type {ContainerSpacing} from '@/modules/foundation/components/container';
import {Container} from '@/modules/foundation/components/container';
import {Heading} from '@/modules/foundation/components/typography/heading';
import type {KeyedArray} from '@/modules/foundation/shared/types';

import type {Person} from '../../shared/types';
import {PersonCard} from '../person-card';

interface Props {
	people: KeyedArray<Person>;
	title?: string;
	spacingTop?: ContainerSpacing;
	spacingBottom?: ContainerSpacing;
}

const PersonList: FC<Props> = ({people, spacingBottom, spacingTop, title}) => {
	return (
		<Container spacingBottom={spacingBottom} spacingTop={spacingTop}>
			{title && (
				<Heading level={2} spacing className={clsx('text-gronn-industri', 'text-3xl!')}>
					{title}
				</Heading>
			)}

			<ul
				className={clsx(
					'grid',
					'grid-cols-1',
					'sm:grid-cols-2',
					'lg:grid-cols-3',
					'gap-12',
				)}
			>
				{people.map((person) => {
					return (
						<li key={person._key}>
							<PersonCard person={person} />
						</li>
					);
				})}
			</ul>
		</Container>
	);
};

export default PersonList;
